export default __webpack_public_path__ + "static/media/up_arrow_blue.6c4325e9.svg";